import React, { Dispatch, useMemo, memo, useRef, useEffect, useState } from 'react';

import { Staff, Subdivision } from '../../types/subdivision';

import { RenderFulledItem } from './renderFullSubdivision';
import { RenderEmptySubdivision } from './renderEmptySubdivision';
import { Organization } from '../../types/organization';

type handleProps = {
  id: number;
  type: string;
};
type ChangeOptions = {
  a: string;
  b: string;
};
type logsInfo = {
  id?: number;
  type?: number;
};

type UpdateEntity = {
  id: number;
  getTree(): void;
  type: number;
};

type ItemProps = {
  setEmployeeInfoShow: Dispatch<boolean>;
  setOrgInfoShow: Dispatch<boolean>;
  tree: Subdivision[];
  branch: number[];
  org: Organization;
  handleSetStaff({ id, type }: logsInfo): void;
  handleOrganizationInfo({ id, type }: handleProps): void;
  previousName: string;
  handleChangeOptions({ a, b }: ChangeOptions): void;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  isSearch: boolean;
  expandArray: string[];
  handleSetEntityLoader(val: boolean): void;
  entityLoader: boolean;
  handleGetTree(): void;
  handleSetEntityUpdateArray({ id, getTree, type }: UpdateEntity): void;
  loadMoreRef?: React.RefObject<HTMLDivElement>;
};

export const RenderTreeItem = memo(({
  setEmployeeInfoShow,
  setOrgInfoShow,
  tree,
  branch,
  org,
  handleSetStaff,
  handleOrganizationInfo,
  previousName,
  handleChangeOptions,
  handleChangeIsKarmaUser,
  isSearch,
  expandArray,
  handleSetEntityLoader,
  entityLoader,
  handleGetTree,
  handleSetEntityUpdateArray,
  loadMoreRef,
}: ItemProps) => {
  // Хуки должны вызываться всегда, даже если tree пустой
  const treeIds = useMemo(() => {
    if (!tree || tree.length === 0) return [];
    return tree.map((subdivision) => subdivision.id);
  }, [tree]);
  
  const baseBranch = useMemo(() => {
    if (treeIds.length === 0) return branch;
    return [...branch, ...treeIds];
  }, [branch, treeIds]);

  // Условный рендеринг внутри компонента
  if (!tree || tree.length === 0) {
    return null;
  }

  // Вычисляем индекс элемента на позиции "длина - 10" для отслеживания скролла
  const itemsToTrack = tree.length > 10 ? tree.length - 10 : -1;

  return (
    <>
      {tree.map((item, index) => {
        // Добавляем ref к элементу на позиции "длина - 10"
        const shouldTrack = index === itemsToTrack && loadMoreRef;
        
        return (
          <div key={item.id} ref={shouldTrack ? loadMoreRef : null}>
            <RenderFulledItem
              item={item}
              branch={baseBranch}
              org={org}
              handleOrganizationInfo={handleOrganizationInfo}
              setEmployeeInfoShow={setEmployeeInfoShow}
              setOrgInfoShow={setOrgInfoShow}
              handleSetStaff={handleSetStaff}
              previousName={previousName}
              handleChangeOptions={handleChangeOptions}
              handleChangeIsKarmaUser={handleChangeIsKarmaUser}
              isSearch={isSearch}
              expandArray={expandArray}
              entityLoader={entityLoader}
              handleSetEntityLoader={handleSetEntityLoader}
              handleGetTree={handleGetTree}
              handleSetEntityUpdateArray={handleSetEntityUpdateArray}
            />
          </div>
        );
      })}
    </>
  );
});
